module.exports = __webpack_public_path__ + "static/media/mobile-screen-lenders.ef8f4c08.png";